import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import axios from 'axios';
import { selectedValuesToArray, paramsToQueryString } from '../../../../../utils.js';
import { getDefaultTableColumnDef, getDefaultTableColumnVisibility } from '../../stats/sales/StatsSalesTableColumnsDef.jsx';
import Paginator from '../../../../../interfaces/paginator';

let cancelToken;
let cancelToken2;
let searchTimeout = null;

// const defaultDashboardFilters = {filters: new Array(12).fill({slug: '', count: 0})};

const prepareStore = (from, set, get) => {
    return {
        initialized: false,
        setInitialized: (initialized) => { set({ initialized }) },

        error: null,
        isLoadedDashboard: false,
        dashboardCategories: [],
        dashboardFilters: [],
        managersSelected: [],
        setManagersSelected: (managersSelected) => { set({ managersSelected }) },

        isLoaded: false,
        view: from == 'page' ? 'block' : 'list',
        viewChange: (view) => {
            set(() => ({ view: view, isLoaded: false, requestsHotels: [] }));
            get().getRequestsHotels();
        },
        requestsHotels: [],
        nb: 0,
        max: 0,
        categorie: 'active',
        categorieFilter: '',
        membresSelected: [],
        companiesSelected: [],
        date1ListSelected: '',
        date2ListSelected: '',
        dateCustom: [],
        statusListSelected: [],
        prioritySelected: '',
        sourcesListSelected: [],
        budgetSelected: [],
        hotelsListSelected: [],
        segmentsListSelected: [],
        frameworkAgreementId: null,
        frameworkAgreementsListSelected: [],
        productsOrdersTypeSelected: 'all',
        customersViewsSelected: 'all',
        withAccommodationsSelected: 'all',
        withMeetingRoomsSelected: 'all',
        withFunctionSheetsSelected: 'all',
        sorting: '',
        search: '',
        handleSearch: (value) => {
            let searchValue = value.target ? (value.target.value || '') : value;

            if (searchValue?.length == 0 || searchValue?.length > 2) {
                if (searchTimeout != null) clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    set({ 
                        categorieFilter: '',
                        categorie: searchValue == '' ? get().categorie : 'all', 
                        search: searchValue.trim()
                    });
                    get().pagination.setPage(1); // on remet la pagination à la première page
                    get().getRequestsHotels();
                    get().getDashboardData();
                }, 500);
            }
        },
        limit: 20,
        offset: 0,
        parameters: '',

        calendarStart: null,
        calendarEnd: null,

        columnOrder: [
            'requests_id',
            'date_activated',
            'rh_status',
            'hotels_title',
            'client',
            'client_prenom',
            'client_nom'
        ],
        columnDef: getDefaultTableColumnDef(),
        columnVisibility: getDefaultTableColumnVisibility(),

        pagination: new Paginator(),
        changePage: (number) => {
            get().pagination.setPage(number);
            get().getRequestsHotels();
        },

        clientId: null,
        setClientId: (clientId) => {
            set({ clientId });
        },
        companyId: null,
        setCompanyId: (companyId) => {
            set({ companyId });
        },
        setFrameworkAgreementId: (frameworkAgreementId) => {
            if ( !frameworkAgreementId ) return;
            // get().filterChange('framework_agreements', [{value: +frameworkAgreementId, label: 'xxx'}]); // Dommage, ça ne fonctionne pas
            set({ isLoaded: false, frameworkAgreementId: frameworkAgreementId, frameworkAgreementsListSelected: [{value: +frameworkAgreementId, label: 'xxx'}] });
            get().getRequestsHotels();
            get().getDashboardData();
        },

        updateOneRequest: async (updatedRequestHotelId) => {
            const newRequestsHotels = [...get().requestsHotels];
            const index = newRequestsHotels.findIndex(r => parseInt(r.requests_hotels.id) === updatedRequestHotelId);
            if (index !== -1) {
                const url1 = ENV.base_lang_url + "myspace/providers//requests_hotels/get_one_requests_hotels?requests_hotels_id=" + updatedRequestHotelId;
                try {
                    const res1 = await fetch(url1).then(res => res.json());
                    newRequestsHotels[index] = res1.requests_hotels;
                    set({ requestsHotels: newRequestsHotels });
                } catch (error) {
                    set({ error });
                }
            }
        },

        getRequestsHotels: async () => {
            set({ isLoaded: false, offset: get().offset + get().limit })

            if (cancelToken) {
                cancelToken.cancel("Operation canceled due to new request.");
            }
            cancelToken = axios.CancelToken.source();

            if (get().view === 'stats') {
                let params = get().constructStatsParams();
                let groups = [];
                for (var key in get().columnVisibility) {
                    if (get().columnVisibility[key]) {
                        groups.push(key);
                    }
                }
                params = { ...params, 'groups': groups };

                try {
                    const result = await axios.get(ENV.api_backyou.url + "stats/sales", {
                        params,
                        headers: {
                            "accept": "application/json",
                            "X-AUTH-TOKEN": ENV.api_backyou.key,
                            "MUID": membres_uid,
                            "SUID": societes_uid,
                            "lang": ENV.lang
                        },
                        cancelToken: cancelToken.token
                    });

                    set({
                        isLoaded: true,
                        loadMore: false,
                        requestsHotels: result.data,
                        max: result.data.length,
                    });
                } catch (error) {
                    if (!axios.isCancel(error)) {
                        set({ error });
                    }
                }
            } else {

                const page = get().pagination.page;
                if ( typeof(page) == 'undefined' ) {
                    get().pagination.setPage(1);
                }

                let parameters = get().constructParams();

                try {
                    const result = await axios.get(`${ENV.base_lang_url}myspace/${'client' == AUTH.frontloginas ? 'clients' : 'providers'}//requests_hotels/get_requests_hotels_list?&${parameters}`, {
                        cancelToken: cancelToken.token
                    });

                    let finalRequestsHotels = result.data.requests_hotels;
                    if (get().view == 'pipeline') {
                        finalRequestsHotels = result.data.pipeline_by_status;
                    }

                    get().pagination.updateNoAPI(result.data.max_requests_hotels);

                    set({
                        isLoaded: true,
                        requestsHotels: finalRequestsHotels,
                        nb: result.data.nb_requests_hotels,
                        max: result.data.max_requests_hotels
                    });
                } catch (error) {
                    if (!axios.isCancel(error)) {
                        set({ error });
                    }
                }
            }
        },

        getDashboardData: async (e) => {
            set({ isLoadedDashboard: false });

            let parameters = get().constructParams();

            if (typeof cancelToken2 != typeof undefined) {
                cancelToken2.cancel("Operation canceled due to new request.")
            }
            cancelToken2 = axios.CancelToken.source();

            try {
                const result = await axios.get(
                    `${ENV.base_lang_url}myspace/${'client' == AUTH.frontloginas ? 'clients' : 'providers'}//requests_hotels/get_dashboard_filters?${parameters}`,
                    { cancelToken: cancelToken2.token }
                );

                set({
                    isLoadedDashboard: true,
                    dashboardCategories: result.data.categories,
                    dashboardFilters: result.data.filters
                });

            } catch (error) {
                set({
                    // isLoadedDashboard: false,
                    error
                });
            }
        },

        resetDashboardDataEmptyFilter: (categories, filters) => {
            if (categories.length && filters.length) {
                const categoryIndex = categories.indexOf(get().categorie) ?? 0;
                const currentFilterList = filters[categoryIndex] ?? {};
                if (Object.keys(currentFilterList).length) {
                    currentFilterList.filters.map((data) => {
                        if (categorieFilter === data.slug && parseInt(data.count) === 0) {
                            set({ categorieFilter: '', search: '' });
                            get().getRequestsHotels();
                            get().getDashboardData();
                        }
                    });
                }
            }
        },

        calendarChange: (value) => {
            set({ calendarStart: value.activeStart, calendarEnd: value.activeEnd });
            get().getRequestsHotels();
        },

        changeColumnVisibility: (columnVisibility) => {
            set({ columnVisibility: columnVisibility });
            get().getRequestsHotels();
        },

        dashboardCategorieChange: (value) => {
            set({ categorie: value, categorieFilter: '', search: '', statusListSelected: [] });
            get().pagination.setPage(1)
            get().getRequestsHotels();
            get().getDashboardData();
        },

        dashboardFilterChange: (value) => {
            const newValue = value === get().categorieFilter ? '' : value;
            get().pagination.setPage(1)
            set({ categorieFilter: newValue });
            get().getRequestsHotels();
        },

        managerChange: (value) => {
            set({ managersSelected: value });
            get().getRequestsHotels();
            get().getDashboardData();
        },

        constructParams: (info = null) => {
            let params = paramsToQueryString({
                'membres': get().clientId != null ? [get().clientId] : get().membresSelected,
                'companies': get().companyId != null ? [get().companyId] : get().companiesSelected,
                'categorie': (get().clientId != null || get().companyId != null) ? 'all' : get().categorie,
                'categorieFilter': get().categorieFilter,
                'date1': get().date1ListSelected,
                'date2': get().date2ListSelected,
                'date3': get().date2ListSelected === 'custom' ? [new Date(get().dateCustom.startDate || null), new Date(get().dateCustom.endDate || null)] : [],
                'calendar_view': get().view == 'calendar' ? [get().calendarStart, get().calendarEnd] : null,
                'status': get().statusListSelected,
                'budget': selectedValuesToArray(get().budgetSelected),
                'sources': selectedValuesToArray(get().sourcesListSelected),
                'hotels': selectedValuesToArray(get().hotelsListSelected),
                'segments': selectedValuesToArray(get().segmentsListSelected),
                'framework_agreements': selectedValuesToArray(get().frameworkAgreementsListSelected),
                'products_orders_type': get().productsOrdersTypeSelected,
                'managers': selectedValuesToArray(get().managersSelected),
                'customers_views': get().customersViewsSelected,
                'with_accommodations': get().withAccommodationsSelected,
                'with_meeting_rooms': get().withMeetingRoomsSelected,
                'with_function_sheets': get().withFunctionSheetsSelected,
                'view': get().view,
                'sorting': get().sorting,
                'search': get().search,
                'limit': typeof get().pagination.itemsPerPage != 'undefined' ? get().pagination.itemsPerPage : get().limit,
                'offset': typeof get().pagination.page != 'undefined' ? (get().pagination.page-1) : get().offset,
                'priority': get().prioritySelected
            });

            set({ parameters: params });
            return params;
        },

        constructStatsParams: () => {
            let params = {
                'categorie': get().categorie,
                'categorieFilter': get().categorieFilter,
                'date1': get().date1ListSelected,
                'date2': get().date2ListSelected,
                'date3[0]': get().dateCustom.startDate ?? null,
                'date3[1]': get().dateCustom.endDate ?? null,
                'rh_acc_status': get().statusListSelected,
                'hotels_id': selectedValuesToArray(get().hotelsListSelected),
                'managers_id': selectedValuesToArray(get().managersSelected),
                'segments_id': selectedValuesToArray(get().segmentsListSelected),
                'framework_agreements_id': selectedValuesToArray(get().frameworkAgreementsListSelected),
                'products_orders_type': get().productsOrdersTypeSelected,
                'sources': selectedValuesToArray(get().sourcesListSelected),
                'customers_views': get().customersViewsSelected,
                'with_accommodations': get().withAccommodationsSelected,
                'with_meeting_rooms': get().withMeetingRoomsSelected,
                'with_function_sheets': get().withFunctionSheetsSelected,
                'priority' : get().prioritySelected,
                'search': get().search,
                'sorting': get().sorting,
                'pagination': false
            };

            if (get().budgetSelected && (get().budgetSelected != get().budgetRange)) {
                params = { ...params, budget: get().budgetSelected };
            }

            return params;
        },

        sortingChange: (value) => {
            set({ sorting: value });
            get().getRequestsHotels();
        },

        filterChange: (value, filter) => {
            switch (filter) {
                case 'date1':
                    set({ isLoaded: false, date1ListSelected: value });
                    break;
                case 'date2':
                    set({ isLoaded: false, date2ListSelected: value });
                    break;
                case 'daterange':
                    set({ isLoaded: false, dateCustom: value });
                    break;
                case 'status':
                    set({ isLoaded: false, statusListSelected: selectedValuesToArray(value) });
                    break;
                case 'budget':
                    set({ isLoaded: false, budgetSelected: value });
                    break;
                case 'sources':
                    set({ isLoaded: false, sourcesListSelected: value });
                    break;
                case 'hotels':
                    set({ isLoaded: false, hotelsListSelected: value });
                    break;
                case 'segments':
                    set({ isLoaded: false, segmentsListSelected: value });
                    break;
                case 'framework_agreements':
                    set({ isLoaded: false, frameworkAgreementsListSelected: value });
                    break;
                case 'customers_views':
                    set({ isLoaded: false, customersViewsSelected: value });
                    break;
                case 'with_accommodations':
                    set({ isLoaded: false, withAccommodationsSelected: value });
                    break;
                case 'with_meeting_rooms':
                    set({ isLoaded: false, withMeetingRoomsSelected: value });
                    break;
                case 'with_function_sheets':
                    set({ isLoaded: false, withFunctionSheetsSelected: value });
                    break;
                case 'products_orders_type':
                    set({ isLoaded: false, productsOrdersTypeSelected: value });
                default:
                    break;
            }
            get().pagination.setPage(1);
            get().getRequestsHotels();
            get().getDashboardData();
        },

        priorityChange : (prioritySlug) => {
            set({ isLoaded: false, prioritySelected: prioritySlug });
            get().getRequestsHotels();
            get().getDashboardData();
        },

        filterClear: () => {

            set({
                sorting: '',
                date1ListSelected: '',
                date2ListSelected: '',
                dateCustom: [],
                statusListSelected: [],
                budgetSelected: [],
                sourcesListSelected: [],
                hotelsListSelected: [],
                segmentsListSelected: [],
                frameworkAgreementsListSelected: get().frameworkAgreementId ? [{value: +get().frameworkAgreementId, label: 'xxx'}] : [],
                productsOrdersTypeSelected: 'all',
                customersViewsSelected: 'all',
                withAccommodationsSelected: 'all',
                withMeetingRoomsSelected: 'all',
                withFunctionSheetsSelected: 'all',
                //prioritySelected:'',
                // categorie: 'all', 
                search: '',
            });

            document.getElementById("global_search").value = "";
            document.getElementById("global_search_remove_filter").classList.add("d-none");
            get().pagination.setPage(1);
            get().getRequestsHotels();
            get().getDashboardData();
        },

        clear: () => {
            set({
                managersSelected: [],
                sorting: '',
                date1ListSelected: '',
                date2ListSelected: '',
                dateCustom: [],
                statusListSelected: [],
                budgetSelected: [],
                sourcesListSelected: [],
                hotelsListSelected: [],
                segmentsListSelected: [],
                frameworkAgreementsListSelected: get().frameworkAgreementId ? [{value: +get().frameworkAgreementId, label: 'xxx'}] : [],
                productsOrdersTypeSelected: 'all',
                customersViewsSelected: 'all',
                withAccommodationsSelected: 'all',
                withMeetingRoomsSelected: 'all',
                withFunctionSheetsSelected: 'all',
                search: '',
                //prioritySelected:'',
                // categorie: 'all', 
                initialized: false
            });
        }
    };
}

const createStore = (from = '') => create(from === 'page' ? persist(
    (set, get) => ({
        ...prepareStore(from, set, get)
    }),
    {
        name: `requests-hotels-store-${from}-${(typeof AUTH != "undefined" ? (AUTH?.membres_id || '') : '')}`,
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => {
            const {
                offset,
                requestsHotels,
                parameters,
                columnDef,
                columnOrder,
                columnVisibility,
                pagination,
                ...rest
            } = state;
            return rest;
        },
    }
) : (set, get) => ({
        ...prepareStore(from, set, get)
    })
);

export default createStore;
